import React, { type ReactNode } from "react";

export type ShowProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  when: boolean;
};

export const Show = ({ children, when, fallback }: ShowProps) => {
  if (when) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};
